(function() {

    // Add scrolled-class to body when user has scrolled
    let doc = document,
        body = doc.body;
    const checkScroll = () => {
        let top = window.pageYOffset || doc.documentElement.scrollTop
        if(top > 0) body.classList.add("scrolled");
        else body.classList.remove("scrolled");
    }
    window.onscroll = function (e) { checkScroll(); }
    checkScroll();

    //Menu toggle
    const menuToggleBtn = doc.getElementById("menu-toggle"),
        header = doc.querySelector("header");
    if(menuToggleBtn && header) {
        menuToggleBtn.addEventListener("click", () => {
            header.classList.toggle("opened");
        });
    }

    //Fade in Elements when in view
    //Animate elements
    const animatedElements = document.querySelectorAll('[class*=\'fade-in\'], [class*=\'slide-in-from-top\'], [class*=\'slide-in-from-right\'], [class*=\'slide-in-from-bottom\'], [class*=\'slide-in-from-left\']');
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.1 }
    );
    if(animatedElements) animatedElements.forEach((el) => observer.observe(el));


})();